
{
  "familyId": "TGL-GELD-TERUGREKENEN",
  "questions": [
    {
      "id": "TGL-GELD-TERUGREKENEN-001",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een artikel kost na 20% korting €80. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€96", "€64", "€160"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_20pct",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij korting",
            "content": "Na 20% korting is de prijs 80% van het origineel (100% − 20% = 80%). Origineel = kortingsprijs ÷ 0,80. Hier: €80 ÷ 0,80 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% korting is de prijs 80% van de originele prijs (100% − 20% = 80%). Terugrekenen: origineel = €80 ÷ 0,80 = €100.",
        "distractorExplanations": {
          "0": "Goed! €80 is 80% van het origineel. €80 ÷ 0,80 = €100.",
          "1": "€96 klopt niet. Je hebt 20% van €80 opgeteld (€80 + €16 = €96), maar dat is niet de methode. De kortingsprijs is al 80% van het origineel: €80 ÷ 0,80 = €100.",
          "2": "€64 klopt niet. Je hebt de korting nog een keer afgetrokken (€80 − €16 = €64). De prijs na korting is al €80. Terugrekenen: €80 ÷ 0,80 = €100.",
          "3": "€160 klopt niet. Je hebt €80 × 2 gerekend. Maar 20% korting betekent dat €80 = 80% van het origineel. Origineel = €80 ÷ 0,80 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-002",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 10% verhoogd naar €110. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€121", "€99", "€120"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_10pct",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij verhoging",
            "content": "Na 10% verhoging is de prijs 110% van het origineel (100% + 10% = 110%). Origineel = verhoogde prijs ÷ 1,10. Hier: €110 ÷ 1,10 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% verhoging is de prijs 110% van de originele prijs (100% + 10% = 110%). Terugrekenen: origineel = €110 ÷ 1,10 = €100.",
        "distractorExplanations": {
          "0": "Goed! €110 is 110% van het origineel. €110 ÷ 1,10 = €100.",
          "1": "€121 klopt niet. Je hebt de prijs nog een keer verhoogd (€110 + 10% van €110 = €121). Maar je moet terugrekenen: €110 ÷ 1,10 = €100.",
          "2": "€99 klopt niet. Je hebt 10% van €110 afgetrokken (€110 − €11 = €99), maar je moet delen door 1,10: €110 ÷ 1,10 = €100.",
          "3": "€120 klopt niet. Je hebt €10 opgeteld. Terugrekenen: €110 ÷ 1,10 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-003",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een fiets kost na 25% korting €60. Wat was de oorspronkelijke prijs?",
      "options": ["€80", "€75", "€45", "€85"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_25pct",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 25% korting",
            "content": "Na 25% korting is de prijs 75% van het origineel (100% − 25% = 75%). Origineel = €60 ÷ 0,75 = €80.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 25% korting is de prijs 75% van de originele prijs (100% − 25% = 75%). Terugrekenen: origineel = €60 ÷ 0,75 = €80.",
        "distractorExplanations": {
          "0": "Goed! €60 is 75% van het origineel. €60 ÷ 0,75 = €80.",
          "1": "€75 klopt niet. Je hebt 25% van €60 opgeteld (€60 + €15 = €75), maar dat is niet de methode. Origineel = €60 ÷ 0,75 = €80.",
          "2": "€45 klopt niet. Je hebt de korting nog een keer afgetrokken (€60 − €15 = €45). Terugrekenen: €60 ÷ 0,75 = €80.",
          "3": "€85 klopt niet. Je hebt €25 opgeteld. Origineel = €60 ÷ 0,75 = €80."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-004",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een artikel kost na 10% korting €90. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€99", "€81", "€110"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_10pct",
      "variantIndex": 4,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 10% korting",
            "content": "Na 10% korting is de prijs 90% van het origineel (100% − 10% = 90%). Origineel = €90 ÷ 0,90 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% korting is de prijs 90% van de originele prijs (100% − 10% = 90%). Terugrekenen: origineel = €90 ÷ 0,90 = €100.",
        "distractorExplanations": {
          "0": "Goed! €90 is 90% van het origineel. €90 ÷ 0,90 = €100.",
          "1": "€99 klopt niet. Je hebt 10% van €90 opgeteld (€90 + €9 = €99), maar je moet delen door 0,90: €90 ÷ 0,90 = €100.",
          "2": "€81 klopt niet. Je hebt de korting nog een keer afgetrokken (€90 − €9 = €81). Origineel = €90 ÷ 0,90 = €100.",
          "3": "€110 klopt niet. Je hebt €20 opgeteld. Terugrekenen: €90 ÷ 0,90 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-005",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 20% verhoogd naar €120. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€144", "€96", "€140"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_20pct",
      "variantIndex": 5,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 20% verhoging",
            "content": "Na 20% verhoging is de prijs 120% van het origineel (100% + 20% = 120%). Origineel = €120 ÷ 1,20 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% verhoging is de prijs 120% van de originele prijs (100% + 20% = 120%). Terugrekenen: origineel = €120 ÷ 1,20 = €100.",
        "distractorExplanations": {
          "0": "Goed! €120 is 120% van het origineel. €120 ÷ 1,20 = €100.",
          "1": "€144 klopt niet. Je hebt de prijs nog een keer verhoogd (€120 + 20% van €120 = €144). Terugrekenen: €120 ÷ 1,20 = €100.",
          "2": "€96 klopt niet. Je hebt 20% van €120 afgetrokken (€120 − €24 = €96), maar je moet delen door 1,20: €120 ÷ 1,20 = €100.",
          "3": "€140 klopt niet. Je hebt €20 opgeteld. Origineel = €120 ÷ 1,20 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-006",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een jas kost na 30% korting €70. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€91", "€49", "€130"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_30pct",
      "variantIndex": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 30% korting",
            "content": "Na 30% korting is de prijs 70% van het origineel (100% − 30% = 70%). Origineel = €70 ÷ 0,70 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 30% korting is de prijs 70% van de originele prijs (100% − 30% = 70%). Terugrekenen: origineel = €70 ÷ 0,70 = €100.",
        "distractorExplanations": {
          "0": "Goed! €70 is 70% van het origineel. €70 ÷ 0,70 = €100.",
          "1": "€91 klopt niet. Je hebt 30% van €70 opgeteld (€70 + €21 = €91), maar je moet delen door 0,70: €70 ÷ 0,70 = €100.",
          "2": "€49 klopt niet. Je hebt de korting nog een keer afgetrokken (€70 − €21 = €49). Origineel = €70 ÷ 0,70 = €100.",
          "3": "€130 klopt niet. Je hebt €60 opgeteld. Terugrekenen: €70 ÷ 0,70 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-007",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een telefoon kost na 15% korting €85. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€97,75", "€72,25", "€115"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_15pct",
      "variantIndex": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 15% korting",
            "content": "Na 15% korting is de prijs 85% van het origineel (100% − 15% = 85%). Origineel = €85 ÷ 0,85 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 15% korting is de prijs 85% van de originele prijs (100% − 15% = 85%). Terugrekenen: origineel = €85 ÷ 0,85 = €100.",
        "distractorExplanations": {
          "0": "Goed! €85 is 85% van het origineel. €85 ÷ 0,85 = €100.",
          "1": "€97,75 klopt niet. Je hebt 15% van €85 opgeteld (€85 + €12,75 = €97,75), maar je moet delen door 0,85: €85 ÷ 0,85 = €100.",
          "2": "€72,25 klopt niet. Je hebt de korting nog een keer afgetrokken (€85 − €12,75 = €72,25). Origineel = €85 ÷ 0,85 = €100.",
          "3": "€115 klopt niet. Je hebt €30 opgeteld. Terugrekenen: €85 ÷ 0,85 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-008",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 25% verhoogd naar €125. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€156,25", "€93,75", "€150"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_25pct",
      "variantIndex": 8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 25% verhoging",
            "content": "Na 25% verhoging is de prijs 125% van het origineel (100% + 25% = 125%). Origineel = €125 ÷ 1,25 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 25% verhoging is de prijs 125% van de originele prijs (100% + 25% = 125%). Terugrekenen: origineel = €125 ÷ 1,25 = €100.",
        "distractorExplanations": {
          "0": "Goed! €125 is 125% van het origineel. €125 ÷ 1,25 = €100.",
          "1": "€156,25 klopt niet. Je hebt de prijs nog een keer verhoogd (€125 + 25% van €125 = €156,25). Terugrekenen: €125 ÷ 1,25 = €100.",
          "2": "€93,75 klopt niet. Je hebt 25% van €125 afgetrokken (€125 − €31,25 = €93,75), maar je moet delen door 1,25: €125 ÷ 1,25 = €100.",
          "3": "€150 klopt niet. Je hebt €25 opgeteld. Origineel = €125 ÷ 1,25 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-009",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een laptop kost na 20% korting €400. Wat was de oorspronkelijke prijs?",
      "options": ["€500", "€480", "€320", "€600"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_20pct_large",
      "variantIndex": 9,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 20% korting",
            "content": "Na 20% korting is de prijs 80% van het origineel. Origineel = €400 ÷ 0,80 = €500.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 20% korting is de prijs 80% van de originele prijs (100% − 20% = 80%). Terugrekenen: origineel = €400 ÷ 0,80 = €500.",
        "distractorExplanations": {
          "0": "Goed! €400 is 80% van het origineel. €400 ÷ 0,80 = €500.",
          "1": "€480 klopt niet. Je hebt 20% van €400 opgeteld (€400 + €80 = €480), maar je moet delen door 0,80: €400 ÷ 0,80 = €500.",
          "2": "€320 klopt niet. Je hebt de korting nog een keer afgetrokken (€400 − €80 = €320). Origineel = €400 ÷ 0,80 = €500.",
          "3": "€600 klopt niet. Je hebt €200 opgeteld. Terugrekenen: €400 ÷ 0,80 = €500."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-010",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een dienst kost na 10% verhoging €220. Wat was de oorspronkelijke prijs?",
      "options": ["€200", "€242", "€198", "€210"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_10pct_large",
      "variantIndex": 10,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 10% verhoging",
            "content": "Na 10% verhoging is de prijs 110% van het origineel. Origineel = €220 ÷ 1,10 = €200.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 10% verhoging is de prijs 110% van de originele prijs (100% + 10% = 110%). Terugrekenen: origineel = €220 ÷ 1,10 = €200.",
        "distractorExplanations": {
          "0": "Goed! €220 is 110% van het origineel. €220 ÷ 1,10 = €200.",
          "1": "€242 klopt niet. Je hebt de prijs nog een keer verhoogd (€220 + 10% van €220 = €242). Terugrekenen: €220 ÷ 1,10 = €200.",
          "2": "€198 klopt niet. Je hebt 10% van €220 afgetrokken (€220 − €22 = €198), maar je moet delen door 1,10: €220 ÷ 1,10 = €200.",
          "3": "€210 klopt niet. Je hebt €10 afgetrokken. Origineel = €220 ÷ 1,10 = €200."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-011",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een artikel kost na 40% korting €60. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€84", "€36", "€140"],
      "correctAnswer": 0,
      "conceptId": "reverse_discount_40pct",
      "variantIndex": 11,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 40% korting",
            "content": "Na 40% korting is de prijs 60% van het origineel (100% − 40% = 60%). Origineel = €60 ÷ 0,60 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 40% korting is de prijs 60% van de originele prijs (100% − 40% = 60%). Terugrekenen: origineel = €60 ÷ 0,60 = €100.",
        "distractorExplanations": {
          "0": "Goed! €60 is 60% van het origineel. €60 ÷ 0,60 = €100.",
          "1": "€84 klopt niet. Je hebt 40% van €60 opgeteld (€60 + €24 = €84), maar je moet delen door 0,60: €60 ÷ 0,60 = €100.",
          "2": "€36 klopt niet. Je hebt de korting nog een keer afgetrokken (€60 − €24 = €36). Origineel = €60 ÷ 0,60 = €100.",
          "3": "€140 klopt niet. Je hebt €80 opgeteld. Terugrekenen: €60 ÷ 0,60 = €100."
        }
      }
    },
    {
      "id": "TGL-GELD-TERUGREKENEN-012",
      "familyId": "TGL-GELD-TERUGREKENEN",
      "module": "TijdGeld",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een prijs is met 50% verhoogd naar €150. Wat was de oorspronkelijke prijs?",
      "options": ["€100", "€225", "€75", "€200"],
      "correctAnswer": 0,
      "conceptId": "reverse_increase_50pct",
      "variantIndex": 12,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen bij 50% verhoging",
            "content": "Na 50% verhoging is de prijs 150% van het origineel (100% + 50% = 150%). Origineel = €150 ÷ 1,50 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Na 50% verhoging is de prijs 150% van de originele prijs (100% + 50% = 150%). Terugrekenen: origineel = €150 ÷ 1,50 = €100.",
        "distractorExplanations": {
          "0": "Goed! €150 is 150% van het origineel. €150 ÷ 1,50 = €100.",
          "1": "€225 klopt niet. Je hebt de prijs nog een keer verhoogd (€150 + 50% van €150 = €225). Terugrekenen: €150 ÷ 1,50 = €100.",
          "2": "€75 klopt niet. Je hebt 50% van €150 afgetrokken (€150 − €75 = €75), maar je moet delen door 1,50: €150 ÷ 1,50 = €100.",
          "3": "€200 klopt niet. Je hebt €50 opgeteld. Origineel = €150 ÷ 1,50 = €100."
        }
      }
    }
  ]
}
